import React from 'react';
import HeroHeader from './HeroHeader';
import LocationSelector from './LocationSelector';
import BookNowButton from './BookNowButton';

const HeroSection = ({
  location,
  onLocationChange,
  cities,
  onBookNowClick,
  isRedirecting,
}) => (
  <section
    className="relative flex-grow flex items-center justify-center bg-cover bg-center bg-no-repeat"
    style={{
      backgroundImage: `url(${require('../../images/SA.jpg')})`,
      backgroundSize: 'calc(100% + 10px) calc(100% + 5px)',
      backgroundPosition: '-5px -5px',
      height: '100vh',
      width: '100%',
    }}
  >
    <div className="absolute inset-0 bg-gray-900 opacity-50 z-0"></div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-7xl relative z-10">
      <HeroHeader />
      <div className="flex flex-col items-end justify-center px-11 md:px-0">
        <LocationSelector
          location={location}
          onChange={onLocationChange}
          cities={cities}
        />
        <BookNowButton onClick={onBookNowClick} isRedirecting={isRedirecting} />
      </div>
    </div>
  </section>
);

export default HeroSection;
